import { z } from 'zod';
import { ActionTypeSchema } from './actionTypes';
import { GameStatusSchema, LooseGameSchema, GameIdSchema } from '../games';
import { AccountIdSchema } from '../accounts';
import { NumericalIdSchema } from '../commonTypes';
export var fetchGameActionSchema = z.object({
    type: ActionTypeSchema.extract(['FETCH_GAME']),
    data: LooseGameSchema
});
export var deleteGameActionSchema = z.object({
    type: ActionTypeSchema.extract(['DELETE_GAME']),
    data: z.object({
        id: GameIdSchema
    })
});
export var changeGameAccountStatusActionSchema = z.object({
    type: ActionTypeSchema.extract(['CHANGE_GAME_ACCOUNT_STATUS']),
    data: z.object({
        game_id: GameIdSchema,
        status: GameStatusSchema
    })
});
export var updateGameTrackableSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_GAME_TRACKABLE_MAPPING']),
    data: z.object({
        account_id: AccountIdSchema,
        game_id: GameIdSchema,
        game_product_id: NumericalIdSchema,
        mapped_product_id: NumericalIdSchema
    })
});
export var gameStateActionsSchema = z.discriminatedUnion('type', [
    fetchGameActionSchema,
    deleteGameActionSchema,
    changeGameAccountStatusActionSchema,
    updateGameTrackableSchema
]);
